import { attrValAssocObj } from "../../DesignerAttributes/data";
import { Box, List } from "@mui/material";
import { attrTableStrColumnsObj } from "components/PimDashboard/data";
import { inputTypes, arrType } from "data/globalData";
import RenderStyleInputField from "../RenderStyleInputFieldNU/RenderStyleInputField";
import { getColDefaultValue } from "components/PimDashboard/data";
import { PimDashboardState } from "context/PimDashboardContext";

export const removeDropdownOptionsBasedonDependency = (column, data, options, allAttributes) => {
	if (
		(column[attrTableStrColumnsObj.input_type.key] === inputTypes.SELECT.key ||
			column[attrTableStrColumnsObj.input_type.key] === inputTypes.MULTIPLE_SELECT.key) &&
		options
	) {
		let list = [];
		console.log(column, allAttributes, "columnsd.........");

		let dependentCols = allAttributes?.filter((row) => column?.dependency?.[row.key] === true);

		if (dependentCols?.length) {
			column[attrValAssocObj]?.forEach((attrVal) => {
				let push = true;
				dependentCols.forEach((col) => {
					if (data?.[col?.linked_table][col.key] && data?.[col?.linked_table][col.key] !== getColDefaultValue(col))
						if (attrVal?.dependency?.[col.key]?.includes(data?.[col?.linked_table][col.key])) {
						} else push = false;
				});
				if (push) list.push(attrVal);
			});
		} else list = column[attrValAssocObj];
		if (column.key === "category") console.log(column, dependentCols, list, "dependentCols.........");

		return {
			type: arrType,
			list: list.map((val) => ({ name: val?.value, key: val?.value })),
		};
	} else return {};
};
const RenderAttributeInputs = ({ columns, setData, data, width, attrGrp, errObj, setErrorObj, itemWidth, disabledColumns = [] }) => {
	return (
		<Box
			display="flex"
			width={width ? width : "100%"}
			flexWrap="wrap"
			p={1}
			columnGap="1%"
			sx={{ rowGap: "8px" }}
			alignItems="flex-start"
			rowGap="3px">
			{errObj &&
				columns?.map((column) => (
					<InputItem
						key={data}
						column={column}
						data={data}
						setData={setData}
						attrGrp={attrGrp}
						errObj={errObj}
						setErrorObj={setErrorObj}
						itemWidth={itemWidth}
						disabledColumns={disabledColumns}
					/>
				))}
		</Box>
	);
};
export default RenderAttributeInputs;

const InputItem = ({ column, data, setData, attrGrp, errObj, setErrorObj, itemWidth = "24%", disabledColumns = [] }) => {
	const { allAttributes } = PimDashboardState();

	console.log(column, "[attrGrpId][attrGrpId]");
	let options = {};
	options = removeDropdownOptionsBasedonDependency(column, data, column?.[attrValAssocObj], allAttributes);

	return (
		<RenderStyleInputField
			column={{ ...column, [attrValAssocObj]: options }}
			data={data}
			setData={setData}
			selectOptObjName={attrValAssocObj}
			width={itemWidth}
			longWidth={itemWidth}
			attrGrp={attrGrp}
			error={!!errObj?.[column.key]}
			errorObj={errObj}
			setError={setErrorObj}
			disabled={disabledColumns.includes(column.key)}
			// dependencyColData={}
		/>
	);
};
